import ReferralNotesCard from './ReferralNotesCard';

export default ReferralNotesCard;
